import { Button } from "@nextui-org/button"
import { commonMainBtnClasses } from "./commonMainBtnClasses"

export function GradientButton({ children, className, ...props }) {
    return (
        <Button {...props} className={`rounded-full bg-gradient-to-r from-primaryBg to-secondaryBg ${commonMainBtnClasses} ${className}`} data-hover={false} >{children}</Button>
    )
}
